import { createSelector } from '@reduxjs/toolkit';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';
import { EosService } from 'gql/EosService';
import { EosServiceState, eosServiceAdapter } from './EosServiceSlice';

const selectSelf = (state: RootState): EosServiceState => {
  return state.eosService;
};

const selectEosServiceState = createSelector(selectSelf, (state: EosServiceState): ActionStatus => {
  return state.loadingState.status;
});

const selectEosServiceStarted = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.loadingState.status !== ActionStatus.IDLE;
});

const selectEosServiceProcessing = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.loadingState.status === ActionStatus.PROCESSING;
});

const selectEosServices = createSelector(selectSelf, (state: EosServiceState): EosService[] => {
  return eosServiceAdapter.getSelectors().selectAll(state.eosServices);
});

const selectEosService = createSelector(selectSelf, (state: EosServiceState): EosService | undefined => {
  return state.eosService;
});

// CREATE
const selectCreateProcessing = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectCreateEosServiceId = createSelector(selectSelf, (state: EosServiceState): string | undefined => {
  return state.mutatedEosServiceId;
});

const selectCreateSucceeded = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

// UPDATE
const selectUpdateProcessing = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectUpdateSucceeded = createSelector(selectSelf, (state: EosServiceState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

const selectUpdateEosServiceId = createSelector(selectSelf, (state: EosServiceState): string | undefined => {
  return state.mutatedEosServiceId;
});

const EosServiceSelectors = {
  selectEosServiceState,
  selectEosServiceStarted,
  selectEosServiceProcessing,
  selectEosServices,
  selectEosService,
  selectCreateProcessing,
  selectCreateEosServiceId,
  selectCreateSucceeded,
  selectUpdateProcessing,
  selectUpdateEosServiceId,
  selectUpdateSucceeded,
};

export default EosServiceSelectors;
